import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLoader } from "@/components/ui/PageLoader";

const CallbackPage = () => {
  const { isLoading } = useAuth0();
  // Auth0Provider's onRedirectCallback handles navigation
  return <PageLoader />;
};
export default CallbackPage;